<template>
  <div :class="`p_onePass${hide ? ' p_driving_hide' : ''}`">
    <el-form
      v-show="!hide"
      v-loading="loading"
      :model="form"
      ref="myForm"
      :rules="rules"
      hide-required-asterisk
    >
      <!-- 澳門居民身份證編號 -->
      <el-form-item :label="$t('message.idNo')" prop="identityNo">
        <el-input v-model="form.identityNo" disabled></el-input>
      </el-form-item>
      <!-- 澳門流動電話 -->
      <el-form-item :label="$t('message.Verification.mobile')" prop="mobile">
        <el-input
          v-model.number="form.mobile"
          :placeholder="$t('message.Verification.mobile_placeholder')"
          disabled
        ></el-input>
      </el-form-item>
      <!-- 錯誤信息 -->
      <el-form-item v-if="vssData && vssData.spCode != '00'" label="">
        <msg-box
          :code="vssData.spCode"
          :normalCode="['00']"
          :spResult="vssData[`spResult${$t('message.lans')}`]"
        ></msg-box>
      </el-form-item>
      <el-form-item class="submit_btn">
        <GradientBtn
          v-if="vssData && vssData.spCode != '00' && !$store.state.isApp"
          @click="logout"
          >{{ $t("message.logout_account") }}</GradientBtn
        >
        <GradientBtn
          v-if="vssData && vssData.spCode == '00' && $store.state.isApp"
          @click="submit"
          :loading="loading"
          >{{ $t("message.account_submit") }}</GradientBtn
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import i18n from "../../../../public/lang/index";
import GradientBtn from "../../../components/GradientBtn";
import LoginAPI from "../../../api/LoginAPI";
import safpBridgeObj from "../../../plugins/govmo-js-sdk";
import { basePath } from "../../../api/axios";
import CoachRenewApplicationAPI from "../../../api/CoachRenewApplicationAPI";
import HeadmasterRenewApplicationAPI from "../../../api/HeadmasterRenewApplicationAPI";
import MsgBox from "@/components/MsgBox.vue";
export default {
  components: { GradientBtn, MsgBox },
  data() {
    return {
      // form: {},
      serviceType: this.$route.params.serviceType,
      basePath: basePath,
      loading: false,
      hide: true,
      rules: {
        identityNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        mobile: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
      },
      vssData: {},
    };
  },
  computed: {
    form: {
      get() {
        return this.$store.state.verifyForm;
      },
      set(value) {
        this.$store.commit("changeVerifyForm", value);
      },
    },
  },
  methods: {
    submit() {
      this.$refs.myForm.validate((valid) => {
        if (valid) {
          localStorage.setItem("verifyForm", JSON.stringify(this.form));
          this.check();
        }
      });
    },
    // 驗證服務准入條件
    async check() {
      const serviceType = this.serviceType;
      const verifyForm = this.form;
      let identType = "BM";
      let identNo = verifyForm.identityNo;
      const licenseNo = verifyForm.licenseNo || null;
      try {
        this.loading = true;
        let data;
        if (serviceType === "HEADMASTER_RENEW") {
          const res = await HeadmasterRenewApplicationAPI.check(
            serviceType,
            identType,
            identNo,
            licenseNo
          );
          data = res;
        }
        if (serviceType === "COACH_RENEW") {
          const res = await CoachRenewApplicationAPI.check(
            serviceType,
            identType,
            identNo,
            licenseNo
          );
          data = res;
        }
        this.vssData = data;
        // console.log(data);

        const errSpCode = ["00", "D12", "D23", "D27", "D30", "D31", "D32"];
        if (data && data.application && !errSpCode.includes(data.spCode)) {
          this.$message({
            type: "error",
            message: data[`spResult${this.$t("message.lans")}`],
          });
        } else {
          localStorage.setItem("form", "");
          this.$store.commit("changeDocumentType", []);
          localStorage.setItem("verifyForm", JSON.stringify(this.form));
          let path;
          switch (serviceType) {
            case "HEADMASTER_RENEW":
              path = "/school-headmaster-renew";
              break;
            case "COACH_RENEW":
              path = "/school-coach-renew";
              break;
            default:
              break;
          }
          this.$router.push(path);
        }
        this.loading = await false;
        this.hide = await false;
      } catch (error) {
        this.loading = false;
        this.hide = false;
        this.$error(error);
      }
    },
    // 一戶通登入
    accountLogin(code, token) {
      const serviceType = this.serviceType;
      this.loading = true;
      LoginAPI.account(code, token, serviceType)
        .then((res) => {
          this.loading = false;
          localStorage.setItem("accountData", JSON.stringify(res.data));
          localStorage.setItem("accountCode", code);
          localStorage.setItem("authentication", res.headers.authentication);
          this.$set(this.form, "identityNo", res.data.identityNo);
          this.$set(this.form, "identNo", res.data.identityNo);
          // 非澳門電話
          // if(res.data.mobile.indexOf('+') != -1){
          //   return;
          // }else{
          this.$set(this.form, "mobile", res.data.mobile);
          // }
          this.submit();
        })
        .catch((err) => {
          this.loading = false;
          if (err.message.indexOf("401") != -1) {
            if (this.$store.state.isApp) {
              safpBridgeObj.getToken({
                success(res) {
                  console.log(res);
                  if (res && res.authToken) {
                    this.accountLogin(null, res.authToken, serviceType);
                  }
                },
                fail(res) {
                  console.log(res);
                  this.$message({
                    type: "error",
                    message: this.$t("message.accountLoginFailed"),
                  });
                },
              });
            } else {
              this.$router.replace("/personal");
            }
          } else {
            this.$error(err);
            this.$router.replace("/personal");
          }
        });
    },
    // 登出
    logout() {
      const lang = this.$t("message.lang_account");
      window.location.replace(
        `${process.env.VUE_APP_ACCOUNT_PATH}/${lang}/logout/`
      );
    },
  },
  created() {
    const code = this.$route.query.code || null;
    const token =
      sessionStorage.getItem("accountToken") || this.$route.query.token || null;
    const serviceType = this.serviceType;
    const accountCode = localStorage.getItem("accountCode") || null;
    const accountData = JSON.parse(localStorage.getItem("accountData")) || null;
    if ((token || (code && accountCode != code)) && serviceType) {
      this.accountLogin(code, token);
    } else {
      if (!accountData) {
        this.$message({
          type: "error",
          message: this.$t("message.accountLoginFailed"),
        });
      }
      this.$router.push("/personal");
    }
  },
};
</script>

<style lang="scss" scoped>
.p_driving_hide {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: #fff;
}
.captcha_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.getVerify_btn {
  margin-left: 16px;
  min-width: 150px;
}
</style>